import { Pipe, PipeTransform } from '@angular/core';
import { Gotra } from '../../models/Gotra';

/**
 * Generated class for the SearchPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'searchgotra',
})
export class SearchGotraPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  // transform(value: string, ...args) {
  //   return value.toLowerCase();
  // }
  // transform(gotra_array: any[], gotra: string): any[] {
  //   //if(!gotra_array) return [];
  //   if(gotra_array == null)
  //   {
  //     console.log("gotra array null")
  //   }
  //   else
  //   {
  //     console.log("gotra array not null",gotra_array)
  //   }
  //   //if(!gotra) return gotra_array;
  //   if(gotra == null) 
  //   {
  //     console.log("gotra null")
  //   }
  //   else
  //   { 
  //     console.log("gotra is not null",gotra)
  //      gotra = gotra.toLowerCase();
  //     return gotra_array.filter( (g) => {
  //       console.log(g)
  //      // return g.gotra.includes(gotra); // only filter country name
  //       //return g.gotra.toLowerCase().indexOf(gotra.toLowerCase()) > -1;
  //     });
  //   }
    

  // }
  transform(items: any, gotra: any): any {
    if (gotra) {
        gotra = gotra.toLowerCase();
        return items.filter(item => {
            return Object.keys(item).some(
                k => {
                    if (item[k] != null && item[k] != undefined && typeof item[k] == 'string')
                         return item[k].toLowerCase().startsWith(gotra);
                        //return item[k].includes(gotra);
                }
            );
        });
    }
    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/search/search.ts